import { DocumentType } from '~/constants/documentType';
import type { QuoteRequestParams } from '~/services/modules/quotes/types';
import type { QuoteForm } from '~/store/slices/quote/types';
import { resolveFlowPlanId } from '~/utils/flowPlanId';
import { searchNameEquipmentId } from '~/utils/searchNameEquipment';
import { onlyDigitsPhone } from './phoneValidation';

/**
 * `birthDate` só entra no payload quando foi preenchido. Planos que não perguntam a data deixam a store com
 * `''`, e o api-core não converte string vazia em `DateTime`: o `POST /v2/Quotes` responde 400
 * «The supplied value is invalid» e o chat fica parado.
 */
export function optionalBirthDate(birthDate: string | null | undefined): { birthDate?: string } {
  return birthDate ? { birthDate } : {};
}

export function buildSimplifiedQuotePayload(quote: QuoteForm, planSearchParam: string | null): QuoteRequestParams {
  return {
    customer: {
      ...(quote.customer_id && { customer_id: quote.customer_id }),
      name: quote.name,
      email: quote.email,
      mobile_phone: onlyDigitsPhone(quote.phoneNumber),
      document: quote.cpf,
      document_type: DocumentType.CPF,
      gender: quote.gender,
      is_social_name: quote.isSocialName,
      ...optionalBirthDate(quote.birthDate)
    },
    equipment_type_id: searchNameEquipmentId(quote.equipment),
    plan_id: resolveFlowPlanId(planSearchParam, quote.plan_id),
    distributor_id: quote.distributor_id ?? null,
    ...(quote.organization_id != null && quote.organization_id !== '' && { organization_id: quote.organization_id }),
    ...(quote.seller != null && quote.seller !== '' && { seller: quote.seller }),
    quotation_value: quote.equipmentValue,
    value_of_accessories: quote.accessoriesValue,
    has_invoice: quote.hasInvoice,
    is_new: quote.isNewEquipment,
    participates_competition: quote.participatesInCompetitions,
    equipment_material_type: quote.equipmentMaterial,
    equipment_conditions: quote.equipmentCondition,
    international_coverage: quote.continents,
    place_store: quote.placeStore,
    year_of_manufacture: quote.yearOfManufacture
  };
}
